import React from 'react';
import { StyledExpandCollapseButton, Icon } from './ExpandCollapseButton.styles';

const ExpandCollapseButton = ({ expanded, text, toggleExpand }) => {
    const titleText = expanded ? `Visa ${text} på en rad` : `Visa ${text} på flera rader`;

    // Disable focus outline on mouse up
    const onMouseUp = (e) => {
        e.currentTarget.blur();
    };

    return (
        <StyledExpandCollapseButton
            type="button"
            onClick={toggleExpand}
            onMouseUp={onMouseUp}
            aria-expanded={expanded}
            title={titleText}
            active={!expanded}
            data-rt="expand-button"
        >
            <Icon className="svt_icon svt_icon--view-list" aria-hidden="true" active={!expanded} />
            <Icon className="svt_icon svt_icon--view-grid" aria-hidden="true" active={expanded} />
        </StyledExpandCollapseButton>
    );
};

export default ExpandCollapseButton;
